var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_c('use',{attrs:{"xlink:href":"/icons/" + _vm.src + ".svg" + '#icon-' + _vm.nameIcon}},[_c('title',{domProps:{"textContent":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }